import { render, staticRenderFns } from "./createFeeling.vue?vue&type=template&id=35a0ee4e&scoped=true&"
import script from "./createFeeling.vue?vue&type=script&lang=js&"
export * from "./createFeeling.vue?vue&type=script&lang=js&"
import style0 from "./createFeeling.vue?vue&type=style&index=0&id=35a0ee4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0ee4e",
  null
  
)

export default component.exports